import { Component, Input } from '@angular/core';
// this should be a direct reference since referencing the index causes a circular reference
import * as AuthModalActions from '@curbnturf/auth-modal/src/lib/+state/auth-modal.actions';
import { AuthModalState } from '@curbnturf/auth-modal/src/lib/+state/auth-modal.reducer';
import { PlatformService } from '@curbnturf/network/src/lib/platform/platform.service';
import { UrlControlFacade } from '@curbnturf/url-control/src/lib/+state/url-control.facade';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';

@Component({
  selector: 'curbnturf-login-first-modal',
  templateUrl: './login-first-modal.component.html',
  styleUrls: ['./login-first-modal.component.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class LoginFirstModalComponent {
  @Input() text: string;
  @Input() redirect: string;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private platformService: PlatformService,
    private store: Store<AuthModalState>,
    private urlControlFacade: UrlControlFacade,
  ) {}

  close() {
    this.modalController.dismiss();
  }

  openLoginModal() {
    this.urlControlFacade.setRedirectUrl(this.redirect);

    if (this.platformService.isAppContext()) {
      this.navController.navigateRoot('auth/login');
    } else {
      this.store.dispatch(AuthModalActions.openAuthModal({ modal: 'login' }));
    }

    this.close();
  }
}
